import React from "react";
import { CButton, CCol, CContainer, CRow } from "@coreui/react";
import { useHistory } from "react-router-dom";

const Page404 = () => {
  let history = useHistory();

  return (
    <div className="align-items-center">
      <CContainer>
        <CRow className=" justify-content-center mb-5 vertical-center  ">
          <CCol md="3"></CCol>
          <CCol md="6">
            <div className="clearfix">
              <h1 className="float-left display-3 mr-4">404</h1>
              <h4 className="pt-3">Oops! </h4>
              <h4 className="text-muted float-left">
                The page you are looking for was not found.
              </h4>
            </div>
          </CCol>
          <CCol md="3"></CCol>
          <CCol md="3"></CCol>
          {/* </CRow>
        <CRow className=" justify-content-center  vertical-center  "> */}
          <CCol md="6">
            <div style={{ left: "50%" }}>
              <CButton
                className="mt-5"
                color="success"
                onClick={() => history.goBack()}
              >
                Go Back
              </CButton>{" "}
            </div>
          </CCol>
          <CCol md="3"></CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default Page404;
